import games from "@frog/source/data/games.js"
import units from "@frog/source/data/units.js"

const index = {
    "title": "Monster Tamer Tactics",
    "games": games,
    "reference": {
        "units": units,
    }
}

export default index
